import React, { useEffect } from 'react'
import Header from '../components/layout/Header'
import { formatDatee } from '../helpers/formatter'
import { Link } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
function SelectFacilityForList(props) {
    const dispatch = useDispatch();
    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">
                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                    Lütfen başvurularınızı görüntüleyeceğiniz kurumu seçiniz
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <div className='mb-5 columns-2 md:ml-64 ps-5 mt-5 ms-5 me-5 text-xl text-start font-semibold'>
                <Link to="/applications?facility=başkent">
                    <div className="card relative">
                        <img
                            style={{
                                display: 'block',
                                margin: 'auto',
                                width: '200px'
                            }}
                            src="/assets/images/facilities/başkent.png"
                            alt="Image Description"
                        />
                    </div>
                </Link>
                
                <a href="/applications?facility=erciyes">
                    <div className="card relative">
                        <img src="/assets/images/facilities/erciyesuni.png" alt="Image Description" />
                    </div>
                </a>
               
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectFacilityForList);